const Reset = ({ handleClick }) => {
    return (
        <button
            onClick={handleClick}
        >
            Reset
        </button>
    )
}

export default Reset;